import axios from "axios";
import config from "@/../config";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import router from "@/router";

const baseURL =
  process.env.NODE_ENV === "development" ? "/api/" : config.api_base_url_stg;

const apiClient = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
  },
  params: {
    time: new Date().getTime(),
  },
});

// attach token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("user_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// global error toast
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      console.warn("[API] Global 401 handler: Token is invalid or expired.");

      // Clear token
      localStorage.removeItem("user_token");

      // Redirect to login if not already there
      if (router.currentRoute.value.path !== "/login") {
        // Only show one toast for session expiration
        toast.error("Session expired. Please sign in again.", {
          toastId: "session-expired", // prevent duplicate toasts
          autoClose: 5000,
        });
        router.push({ path: "/login", query: { unauthorized: 1 } });
      }
    } else {
      // For other errors, show the message from server
      const msg =
        error.response?.data?.msg ||
        error.response?.data?.message ||
        "Unexpected error";

      toast.error(msg);
    }

    return Promise.reject(error);
  },
);

export default apiClient;
